import {Base} from "@/api/Base"

export class SalaryInformationList extends Base {
    path = "salaryInformation/list"
}